import { createContext, useContext } from "react";

// { flow, saver, submit, otherLabel, otherTextMax } for everything rendered inside a Survey.
const SurveyContext = createContext(null);

export const SurveyProvider = SurveyContext.Provider;

export function useSurvey() {
  return useContext(SurveyContext);
}
